export default "__VITE_ASSET__BeC6TIvf__"